import { DropDownField } from '@epages/react-components'
import type { ReactElement } from 'react'

import FormGroup from '../../../../formComponents/FormGroup'

type Props = {
  categoryOptions: unknown[]
} & TranslateProps

export function CategoryIdSettings({ t, categoryOptions }: Readonly<Props>): ReactElement {
  const defaultOptions = [{ value: '', label: t('collectionDropdown.loadingPlaceholder') }]

  return (
    <FormGroup name="categoryId" tagName="label" label={t('collectionDropdown.label')}>
      <DropDownField name="categoryId" options={categoryOptions || defaultOptions} className="ep-form-select" />
    </FormGroup>
  )
}
